<h2 mat-dialog-title>
  {{ translatePrefix + '.title' | translate }}
</h2>

<mat-dialog-content>
  <div class="text">
    <span>{{ translatePrefix + '.description' | translate }}</span>
    <span>
      {{ 'registration.errorDialog.contactSupport' | translate }}
      <a class="email" href="mailto:{{ environment.branding.supportEmail }}">{{ environment.branding.supportEmail }}</a>
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'common.cancel' | translate }}</button>
  <button mat-flat-button cdkFocusInitial (click)="action()">
    {{ translatePrefix + '.action' | translate }}
  </button>
</mat-dialog-actions>
